import { inject, Injectable } from '@angular/core';
import { first, tap } from 'rxjs/operators';

import { GoogleImportSessionSettingsService, Redirect } from 'app/teachers-shared/services/google-import-session-settings.service';
import { TeacherGoogleClassroomDataService } from 'app/teachers-shared/services/teacher-google-classroom-data.service';

@Injectable({
  providedIn: 'root'
})
export class TeacherGoogleClassroomService {
  private readonly teacherGoogleClassroomDataService = inject(TeacherGoogleClassroomDataService);
  private readonly googleImportSessionSettingsService = inject(GoogleImportSessionSettingsService);

  public importGoogleClassroom(redirect: string[], params?: any): void {
    this.googleImportSessionSettingsService.setProcess(this.googleImportSessionSettingsService.googleClassroomImport);
    this.teacherGoogleClassroomDataService.getAuthenticationUrl()
      .pipe(
        tap((url) => {
          this.googleImportSessionSettingsService.setPendingImport();
          this.googleImportSessionSettingsService.setRedirect({ url: redirect, params: params });
          window.location.href = url;
        }),
        first()
      ).subscribe();
  }

  public importGoogleClassroomStudents(redirect: string[], params?: any): void {
    this.teacherGoogleClassroomDataService.getAuthenticationUrl()
      .pipe(
        tap((url) => {
          this.googleImportSessionSettingsService.setPendingImport();
          this.googleImportSessionSettingsService.setProcess(this.googleImportSessionSettingsService.googleClassroomStudentImport);
          this.googleImportSessionSettingsService.setRedirect({ url: redirect, params: params });
          window.location.href = url;
        }),
        first()
      ).subscribe();
  }

  public isPendingImport(): boolean {
    return this.googleImportSessionSettingsService.isPendingImport();
  }

  public getImportProcess(): string | null {
    return this.googleImportSessionSettingsService.getProcess();
  }

  public clearProcess(): void {
    this.googleImportSessionSettingsService.clearProcess();
    this.googleImportSessionSettingsService.clearRedirect();
    this.googleImportSessionSettingsService.resetPendingImport();
  }

  public getRedirect(): Redirect | null {
    return this.googleImportSessionSettingsService.getRedirect();
  }
}
